<template>
    <div ref="video" @click.stop></div>
</template>

<script>
export default {
    props: {
        url: {
            type: [String],
            default: ""
        },
        id: {
            typee: [String],
            default: ""
        },
        poster: {
            type: [String],
            default: ""
        }
    },
    data() {
        return {};
    },
    mounted() {
        let { id, url, poster } = this.$props;
        this.$refs.video.setAttribute("id", `video${id}`);
        var player = new TcPlayer(`video${id}`, {
            mp4: url,
            autoplay: false, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
            width: 268, //视频的显示宽度，请尽量使用视频分辨率宽度
            height: 151, //视频的显示高度，请尽量使用视频分辨率高度
            poster: poster,
            x5_fullscreen: 'true',
            systemFullscreen: true,
            x5_type: "h5"
        });
    }
};
</script>

<style lang="less">
/*iphoneX、iphoneXs*/
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .vcp-fullscreen.vcp-player .vcp-controls-panel {
        padding-bottom: 34px !important;
    }
}
/*iphone Xs Max*/
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio:3) {
    .vcp-fullscreen.vcp-player .vcp-controls-panel {
        padding-bottom: 34px !important;
    }
}
/*iphone XR*/
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio:2) {
    .vcp-fullscreen.vcp-player .vcp-controls-panel {
        padding-bottom: 34px !important;
    }
} 
</style>
